import usePrivateAxios from "@/common/api/usePrivateAxios";
import { unFormatCurrency } from "@/common/utils/unFormatters";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

interface UpdateEstablishmentProductData {
  id?: string;
  metric: string;
}

interface UseUpdateEstablishmentProductParams {
  onSuccess: () => void;
  onError?: (error: AxiosError) => void;
}

export const useUpdateEstablishmentProduct = ({ onSuccess, onError }: UseUpdateEstablishmentProductParams) => {
  const privateAxios = usePrivateAxios()

  const { mutate, isPending } = useMutation<void, AxiosError, UpdateEstablishmentProductData>({
    mutationKey: ['updateEstablishmentProduct'],
    mutationFn: async (data) => {
      await privateAxios.put(`/establishment/product_prices/${data.id}`, {
        product_price: {
          value:unFormatCurrency(data.metric),
        }
      });
    },
    onSuccess,
    onError,
  });

  return { mutate, isPending: isPending };
};
